/**
 * Runs scroll-based section animations.
 */
document.addEventListener('DOMContentLoaded', function() {
    const footerBanner = document.querySelector('.footer-banner');
    if (!footerBanner) return;

    // Detect if mobile (adjust breakpoint as needed)
    const isMobile = window.innerWidth <= 768;
    
    // Adjust observer threshold for mobile vs desktop
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: isMobile ? .1 : .2
    };

    // Set delays faster on mobile; adjust times as desired
    const delayChev1 = isMobile ? 500 : 600;
    const delayChev2 = isMobile ? 600 : 700;
    const delayChev3 = isMobile ? 700 : 900;
    const delayWrapper = isMobile ? 800 : 1000;
    
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const chev1 = footerBanner.querySelector('.chev-1');
                const chev2 = footerBanner.querySelector('.chev-2');
                const chev3 = footerBanner.querySelector('.chev-3');
                const footerBannerWrapper = footerBanner.querySelector('.footer-banner-wrapper');
                
                setTimeout(() => {
                    if (chev1) {
                        chev1.classList.add('animate');
                    }
                }, delayChev1);
                
                setTimeout(() => {
                    if (chev2) {
                        chev2.classList.add('animate');
                    }
                }, delayChev2);
                
                setTimeout(() => {
                    if (chev3) {
                        chev3.classList.add('animate');
                    }
                }, delayChev3);
                
                setTimeout(() => {
                    if (footerBannerWrapper) {
                        footerBannerWrapper.classList.add('animate');
                    }
                }, delayWrapper);
                
                observer.disconnect();
            }
        });
    }, observerOptions);
    
    observer.observe(footerBanner);
});